/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ mailbox: NonNullable<unknown> }} Connections_Outlook_Revoke_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "The assistant will no longer access {mailbox}. Your synced mail is unaffected." |
*
* @param {Connections_Outlook_Revoke_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const connections_outlook_revoke_confirm_description = /** @type {((inputs: Connections_Outlook_Revoke_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Outlook_Revoke_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Assistent greift nicht mehr auf ${i?.mailbox} zu. Ihre synchronisierten E-Mails sind nicht betroffen.`)
	return /** @type {LocalizedString} */ (`The assistant will no longer access ${i?.mailbox}. Your synced mail is unaffected.`)
});